
export const extraToppings = (s, extraToppings) => {
    $("#" + s + "_extraToppiings").empty();
    extraToppings.forEach((etopp) => {
        let tr_extra = `
        <tr class="col-sm-12 col-xs-12 col-md-12 col-lg-12" key="${etopp.def_ing_id}" id="${s +
            "-current_" +
            etopp.def_ing_id}"
        v-show="${etopp.def_ing_name}">
        <td class="col-sm-1 col-xs-1 col-md-1 col-lg-1">
            <a href="javascript:void(0)" class="add_item" id="${s +
            "_addBtn_" +
            etopp.def_ing_id}"><i class="icon_plus_alt2"  @click.prevent="addCurrentToppings(${s},${etopp.def_ing_id
            })"></i></a> 
        </td>
        <td 
        class="col-sm-8 col-xs-8 col-md-8 col-lg-8"
        style="width:140px" id="${s +
            "_et_topping_name_" +
            etopp.def_ing_id}">
            ${etopp.def_ing_name}
        </td>
        <td class="col-sm-2 col-xs-2 col-md-2 col-lg-2">
            <strong class="pull-right"><span id="${s +
            "_et_price_" +
            etopp.def_ing_id}">
            ${etopp.def_topp_price}</span> </strong>
        </td>
        </tr>
        `;
        $("#" + s + "_extraToppiings").append(tr_extra);
    });
};
export const addToppings = (s, i, ETToppingName, ETPrice) => {
    var html = `
        <tr class="${s + '_extra'} col-sm-12 col-xs-12 col-md-12 col-lg-12" id="${s + '_addedExtraToppings_' + i}">
        <td class="col-sm-1 col-xs-1 col-md-1 col-lg-1">
            <a href="javascript:void(0)" class="remove_item" 
                id="${s + '_removeItem_' + i}"><i class="icon_minus_alt2"></i>
            </a>
        </td>
        <td  
        class="col-sm-8 col-xs-8 col-md-8 col-lg-8"
        style="width:100px" id="${s + '_addedExtraToppingsName_' + i}">${ETToppingName}</td>
        <td class="col-sm-2 col-xs-2 col-md-2 col-lg-2"><strong class="pull-right"><span id="${s + '_addedExtraToppingPrice_' + i}">${ETPrice}</span></strong></td>
        </tr>
    `;
    $("#" + s + '_defaultToppiings').prepend(html);
}
export const removeToppings = (s, i, ETToppingName, ETPrice) => {
    var html = `
        <tr class="${s + '_extra'} col-sm-12 col-xs-12 col-md-12 col-lg-12" id="${s + '-current_' + i}">
        <td class="col-sm-1 col-xs-1 col-md-1 col-lg-1">
            <a href="javascript:void(0)" class="add_item" 
                id="${s + '_addBtn_' + i}"><i class="icon_plus_alt2"></i>
            </a>
        </td>
        <td  
        class="col-sm-8 col-xs-8 col-md-8 col-lg-8"
        style="width:100px" id="${s + '_et_topping_name_' + i}">${ETToppingName}</td>
        <td class="col-sm-2 col-xs-2 col-md-2 col-lg-2"><strong class="pull-right"><span id="${s + '_et_price_' + i}">${ETPrice}</span></strong></td>
        </tr>
    `;
    $("#" + s + '_extraToppiings').prepend(html);
}

export const defaultToppings = (s, defaultToppings) => {
    $("#" + s + "_defaultToppiings").empty();
    defaultToppings.forEach((dtopp) => {
        let tr = `
        <tr key="${"defaultToppings_" + dtopp.def_ing_id}"
            id="${s + "-default_" + dtopp.def_ing_id}"
            class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
            v-show="dtopp.def_ing_name"
            class="db_defaultToppings">
            <td class="col-sm-1 col-xs-1 col-md-1 col-lg-1">
                    <a href="javascript:void(0)" class="remove_item"
                    id="${s + "_removeCurrentToppingBtn_" + dtopp.def_ing_id}"
                    @click.prevent="removeCurrentToppings(${(s,
                dtopp.def_ing_id)})"><i class="icon_minus_alt2"></i></a> 
            </td>
            <td 
            class="col-sm-8 col-xs-8 col-md-8 col-lg-8"
            style="width:140px" id="${s +
            "_ct_topping_name_" +
            dtopp.def_ing_id}">
                    ${dtopp.def_ing_name}
                </td>
            <td class="col-sm-2 col-xs-2 col-md-2 col-lg-2">
                <strong class="pull-right"><span id="${s +
            "_ct_price_" +
            dtopp.def_ing_id}">
                    ${dtopp.def_topp_price}</span></strong>
            </td>
        </tr>
        `;
        $("#" + s + "_defaultToppiings").append(tr);
    });
};
export const cartItem = (orders) => {
    $("#cartItems").empty();
    orders.forEach((items) => {
        let toppingsSelected = '';
        let toppingsRemoved = '';
        if (items.all_toppings.length > 0) {
            items.all_toppings.forEach((topping) => {
                if (topping.type == 'minus') {
                    toppingsRemoved += '<li>- ' + topping.toppings_name + '</li>';
                } else if (topping.type == 'plus') {
                    toppingsSelected += '<li>+ ' + topping.toppings_name + '</li>';
                }
            });
        }
        if (toppingsSelected != '') {
            toppingsSelected = '<ul class="list list-unstyled" style="margin:0;">' + toppingsSelected + '</ul>';
        } else {
            toppingsSelected = '<ul class="list list-unstyled" style="margin:0;"><li>None</li></ul>';
        }
        if (toppingsRemoved != '') {
            toppingsRemoved = '<ul class="list list-unstyled" style="margin:0;">' + toppingsRemoved + '</ul>';
        } else {
            toppingsRemoved = '<ul class="list list-unstyled" style="margin:0;"><li>None</li></ul>';
        }

        let scomm = '';
        let ccomm = '';

        if (items.comments) {
            //html += '<hr style="margin:2px 0">';
            let scomments = null;
            let ccomments = null;
            if (items.comments.indexOf("Checkout Comment:") != -1) {
                let comments = items.comments.split("Checkout Comment:");
                scomments = comments[0];
                ccomments = comments[1];
            }else{
                scomments = items.comments;
            }
            if (scomments) {
                scomm =
                    '<p style="margin:2px 0;">Special Comments: <br><span style="color:red">' +
                    scomments + '</span> </p>';
            }
            if (ccomments) {
                ccomm =
                    '<p style="margin:2px 0;">Checkout Comments: <br><span style="color:red">' +
                    ccomments + '</span> </p>';
            }
        }

        let orderMenu = `
          <div class="col-lg-12" style="border: 1px solid #ceccccf7;border-radius: 4px;margin: 5px 0px 0px 0px;padding-bottom: 5px;padding-right: 15px;margin: 3px 5px 0;width: 96%;position: relative;box-shadow: 1px 1px 2px 2px #d2d1d1ad;">
        <div style="position: absolute; right:15px; top:8px ">
          <a href="javascript:void(0)" class="remove_item" id="menuItem_${items.id
            }" @click.prevent="deleteMenuItem(${items.menu_slug},${items.menu_price
            },${items.id},${items.order_id})"><i class="fa fa-trash"></i></a>
        </div>
        <div>
        <div class="cart-item">
          <strong> ${items.menu_name} </strong>   
        </div>
        <div class="cart-item" style="width:100%; padding:4px 0px;font-size: 13px;">
          
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="padding:0;">
          ${items.menu_size} - ${items.menu_qty} x ${items.menu_price}  
          <div class="pull-right">${"$ " + items.final_menu_price}</div>
          </div>
          <div class="clearfix"></div>
          <div style="display:${items.total_toppings_price == "0.00" ? "none" : "block"
            }">  
          Toppings Price  <div class="pull-right">${"$ " +
            items.total_toppings_price}</div>
          </div>
          <div class="clearfix"></div>
          <div class="col-xs-6" style="padding:5px 5px 0 0;font-size:10px;">
            <strong>Selected Toppings</strong><br>`+ toppingsSelected + `
          </div>
          <div class="col-xs-6" style="padding:5px 0 0 5px;font-size:10px;">
            <strong>Removed Toppings</strong><br>`+ toppingsRemoved + `
          </div>
          <div class="col-xs-12" style="padding:5px 0 0 5px;font-size:10px;">
            `+ scomm+ccomm + `
          </div>
        </div>
        </div>
      </div>
      `;
        $("#cartItems").append(orderMenu);
    });
};
export const subTotal = (sub_total) => {
    $("#sub_total").text("");
    $("#sub_total").text("$ " + sub_total);
};

export const deliveryAmount = (delivery_amount) => {
    $("#delivery_amount").text("");
    $("#delivery_amount").text("$ " + delivery_amount);
};
export const totalAmount = (total_amount) => {
    $("#total_amount").text("");
    $("#total_amount").text("$ " + total_amount);
};
export const myOrders = (order) => {
    let cardSurcharge = ``;
    if(order.gst>0){
        cardSurcharge = `<div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px;">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Card Surcharge 
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${"$ " + order.gst.toFixed(2)}</b>
            </div>
        </div>`;
    }
    let html = `
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="background: rgb(255, 255, 255);
        box-shadow: 1px 1px 2px 2px rgba(0,0,0,0.11);
        padding: 10px 15px;
        border-radius:5px;
        min-height: auto !important;
        margin-bottom: 10px;">
        
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:14px; font-weight: bold;padding-left:0">
        <i class="fa fa-first-order" aria-hidden="true"></i> Order No
        <span style="margin-left:6px;"><b>${order.order_no} - ${"$ " + order.total_amount.toFixed(2)}</b></span>
        <span class="pull-right">${order.status}</span>
        </div>
        <div class="clearfix"></div>
        <hr style="margin:10px 0">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="padding-left:0; padding-right: 0">
            <div class="col-xs-3" 
            style="font-size:13px; padding-left:0">
            
            <span class="fa fa-eye btn btn-sm btn-block btn-success" 
            style="cursor: pointer; letter-spacing:1px" 
            title="Open Details" 
            data-id="${order.order_no}"
            id="${"openOrder_" + order.order_no}"
            >
            Show
            </span>
            
            <span class="fa fa-eye-slash  btn btn-sm btn-danger btn-block" 
            style="cursor: pointer; display: none; letter-spacing:1px; margin-top:0px" 
            title="Close Details" 
            id="${"closeOrder_" + order.order_no}"
            data-id="${order.order_no}"
            >
            Close
            </span>
            </div>

            <div class="col-xs-3" 
            style="font-size:13px;  padding-left:0; padding-right:0; font-size:15px; letter-spacing:1px"> 
            <a href="${order.receipt_url
        }" target="_blank" class="btn btn-sm btn-danger btn-block" style="color: #fff;" title="Tax Invoice">
            <span class="fa fa-print"></span> Tax Invoice
            </a>
            </div>

            <div class="col-xs-3" 
            style="font-size:13px; padding-right:0">            
            <span class="fa fa-undo btn btn-sm btn-block btn-warning" 
            style="cursor: pointer; letter-spacing:1px" 
            title="Repeat Order"
            id="${"repeatOrder_" + order.order_no}" 
            data-id="${order.order_no}"
            >
            Repeat
            </span>
            </div>

            <div class="col-xs-3" 
            style="font-size:13px; padding-right:0">            
            <span class="fa fa-file btn btn-sm btn-block btn-warning" 
            style="cursor: pointer; letter-spacing:1px" 
            title="Order Receipt"
            id="${"taxInvoiceOrder_" + order.order_no}" 
            data-id="${order.order_no}"
            >
            Order Receipt
            </span>
            </div>
        </div>
        
        <div class="clearfix"></div>
            
        <div class="col-lg-12" id="${order.order_no
        }" style="display:none; padding:0px"> 
        <hr style="margin:10px 0">
        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px;display:none;">
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Payer ID 
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${order.payerID}</b>
            </div>
        </div>
        
        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px;">
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Order Date 
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${order.created_at}</b>
            </div>
        </div>

        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px;">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Delivery Type
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${order.delivery_type}</b>
            </div>
        </div>
        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px;">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Delivery Fee 
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${"$ " + order.delivery_amount.toFixed(2)}</b>
            </div>
        </div>
        `+cardSurcharge+`
        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px;padding:10px 0px;">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Sub Total  
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${"$ " + order.sub_total.toFixed(2)}</b>
            </div>
        </div>

        <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12" style="font-size:13px; padding:10px 0px;">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                Grand Total  
            </div>
            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-right">
                <b>${"$ " + order.total_amount.toFixed(2)}</b>
            </div>
        </div>
        <div class="clearfix"></div>
        <h4 style="font-size:13px; font-weight: bold">Menu Details</h4>
        <hr style="margin:3px 0">
        <div class="table-responsive">
            <table class="table table-bordered table-responsive" style="width:1500px;">
                <thead>
                    <tr style="font-weight: bold; font-size: 13px">
                        <td>Menu Items</td>
                        <td>Menu Size</td>
                        <td>Menu Qty</td>
                        <td>Price</td>
                        <td>Menu Price</td>
                        <td>Top Price</td>
                        <td>Total</td>
                        <td>Toppings</td>
                    </tr>
                </thead>
                <tbody id="menuItemDetails_${order.order_no}">
                    
                </tbody>
            </table>
        </div>
    </div>
    `;
    $("#myOrders").append(html);
};

export const myOrdersSide = (order) => {
    let html = `
        <div class="col-xs-12" style="background: rgb(255, 255, 255);
        box-shadow: 1px 1px 2px 2px rgba(0,0,0,0.11);
        padding: 5px;
        border-radius:4px;
        min-height: auto !important;
        margin-bottom: 10px;">
        
        <div class="col-xs-12" style="font-size:12px; font-weight: normal;padding:0">
        <i class="fa fa-first-order" aria-hidden="true"></i>
        <span style="margin-left:6px;"><b>${order.order_no} - ${"$ " + order.total_amount.toFixed(2)}</b></span>
        <span class="pull-right">${order.status}</span>
        </div>
        <div class="clearfix"></div>
        <hr style="margin:5px 0">
        <div class="col-xs-12" style="padding-left:0; padding-right: 0">
            <div class="col-xs-4" 
            style="font-size:12px; padding-left:0">
            
            <span class="fa fa-eye btn btn-xs btn-block btn-success" 
            style="cursor: pointer; letter-spacing:1px" 
            title="Show" 
            data-id="${order.order_no}"
            id="${"openOrderSide_" + order.order_no}"
            >
            Show
            </span>
            
            <span class="fa fa-eye-slash  btn btn-xs btn-danger btn-block" 
            style="cursor: pointer; display: none; letter-spacing:1px; margin-top:0px" 
            title="Close Details" 
            id="${"closeOrderSide_" + order.order_no}"
            data-id="${order.order_no}"
            >
            Hide
            </span>
            </div>

            <div class="col-xs-4" 
            style="font-size:13px;  padding-left:0; padding-right:0; font-size:15px; letter-spacing:1px"> 
            <a href="${order.receipt_url
        }" target="_blank" class="btn btn-xs btn-danger btn-block" style="color: #fff;" title="view_recipet">
            <span class="fa fa-print"></span> Receipt
            </a>
            </div>
            
            <div class="col-xs-4" 
            style="font-size:13px; padding-right:0">            
            <span class="fa fa-undo btn btn-xs btn-block btn-warning" 
            style="cursor: pointer; letter-spacing:1px" 
            title="Repeat Order"
            id="${"repeatOrderSide_" + order.order_no}" 
            data-id="${order.order_no}"
            >
            Repeat
            </span>
            </div>
        </div>
        
        <div class="clearfix"></div>
            
        <div class="col-lg-12" id="${order.order_no
        }" style="display:none; padding:0px"> 
        <hr style="margin:10px 0">
        <div class="row col-xs-12" style="font-size:12px; padding:5px 0px;display:none;">
            <div class="col-xs-4">
                Payer ID 
            </div>
            <div class="col-xs-8 text-right">
                <b>${order.payerID}</b>
            </div>
        </div>
        
        <div class="row col-xs-12" style="font-size:12px; padding:5px 0px">
            <div class="col-xs-4">
                Order Date 
            </div>
            <div class="col-xs-8 text-right">
                <b>${order.created_at}</b>
            </div>
        </div>

        <div class="row col-xs-12" style="font-size:12px; padding:5px 0;display:none;">
        <div class="col-xs-4">
                Delivery Type
            </div>
            <div class="col-xs-8 text-right">
                <b>${order.delivery_type}</b>
            </div>
        </div>
        <div class="row col-xs-12" style="font-size:12px; padding:5px 0;display:none;">
        <div class="col-xs-4">
                Delivery Fee 
            </div>
            <div class="col-xs-8 text-right">
                <b>${"$ " + order.delivery_amount.toFixed(2)}</b>
            </div>
        </div>
        
        <div class="row col-xs-12" style="font-size:12px;padding:5px 0;display:none;">
        <div class="col-xs-4">
                Sub Total  
            </div>
            <div class="col-xs-8 text-right">
                <b>${"$ " + order.sub_total.toFixed(2)}</b>
            </div>
        </div>

        <div class="row col-xs-12" style="font-size:12px; padding:5px 0;display:none;">
        <div class="col-xs-4">
                Grand Total  
            </div>
            <div class="col-xs-8 text-right">
                <b>${"$ " + order.total_amount.toFixed(2)}</b>
            </div>
        </div>
        <div class="clearfix"></div>
        <h4 style="font-size:12px; font-weight: bold">Menu Details</h4>
        <hr style="margin:2px 0">
        <div class="table-responsive">
            <table class="table table-bordered table-responsive" style="width:500px;">
                <thead>
                    <tr style="font-weight: bold; font-size: 13px">
                        <td>Menu Items</td>
                        <td>Menu Size</td>
                        <td>Menu Qty</td>
                        <td>Price</td>
                        <td>Menu Price</td>
                        <td>Top Price</td>
                        <td>Total</td>
                        <td>Toppings</td>
                    </tr>
                </thead>
                <tbody id="menuItemDetails_${order.order_no}">
                    
                </tbody>
            </table>
        </div>
    </div>
    `;
    $("#myOrders").append(html);
};

export const getTaxInvoiceView = (data) => {
    var orderMenu = data.order_menu;
    var address = data.delivery_address || "";
    var html = '<div style=" text-align: left">';
    html += '<div id="printableArea" style=" text-align: left">';
    html += '<div class="table-responsive" >';
    html +=
        '<table class="table table-bordered" style="color: #000">';
    html += '<thead>';

    html +=
        '<tr style="padding:3px 0"><td style="padding:3px 10px;"><p style="font-size:17px;margin:3px 0; text-align:left;"><strong>Order #:</strong> ' +
        data.order_id + '' + '</p></td></tr>';
    html +=
        '<tr style="padding:3px 0"><td style="padding:3px 10px;"><p style="font-size:17px;margin:3px 0; text-align:left;"><strong>Order By:</strong> ' +
        sessionStorage.getItem('auth_name') + ' </p></td></tr>';
    html +=
        '<tr style="padding:3px 0"><td style="padding:3px 10px;"><p style="font-size:17px;margin:3px 0; text-align:left;"><strong>Mobile Number:</strong> ' +
        address.mobile + ' </p></td></tr>';
    if (data.delivery_type == 'delivery') {
        html +=
            '<tr style="padding:3px 0"><td style="padding:3px 10px;"><p style="font-size:17px;margin:3px 0; text-align:left; width:6cm"><strong>Delivery Address:</strong></br> ' +
            address.delivery_address + ', ' + address.province + ', ' + address.city_name +
            ' </p></td></tr>';
    }
    html +=
        '<tr style="text-align:left;background: #fff;color:#000;"><td style="width:8cm;padding: 2px 15px; font-size:18px; font-weight:600">Menu Name</td></tr>';
    html += '</thead><tbody>';

    orderMenu.forEach(value => {
        html +=
            '<tr style="font-size:17px;text-align:left; color: #000; border-bottom:2px solid #000">';
        html += '<td style="padding:2px 11px">' + value.menu_name + '';
        html += '<p style="margin:2px 0">Menu Size: ' + value.menu_size +
            '  <span style="margin-left:15px">' + value.menu_qty + 'x ' + value
                .menu_price + '</span> <span class="pull-right"> $ ' + (parseInt(value
                    .menu_qty) * parseFloat(value.menu_price)) + '</span></p>';
        if (value.total_toppings_price) {
            html += '<p style="margin:2px 0">Toppings: </p>';
        }
        value.selcetdToppings.forEach(cur => {
            if (cur.type) {
                html +=
                    '<p style="margin:2px 0; padding:0px"><b style="margin-right:10px">' +
                    (cur.type == 'plus' ? '+' : '-') + '</b><span>' + cur
                        .def_ing_name + '</span> <span class="pull-right">$' + cur
                        .def_ing_price + '</span></p>';
                html += '<hr style="margin:1px 0">';
            }
        });
        if (value.total_toppings_price) {
            //html += '<hr style="margin:2px 0">';
            //html += '<p style="margin:2px 0">Total Toppings: <span class="pull-right">$ '+ value.total_toppings_price +'</span> </p>';
        }


        //html += '<hr style="margin:2px 0">';
        //html += '<p style="margin:2px 0"> Total Menu Price: <span class="pull-right"> $ ' + value.total_menu_price +' </span> </p>';
        if (value.comments) {
            //html += '<hr style="margin:2px 0">';
            let scomments = null;
            let ccomments = null;
            if (value.comments.indexOf("Checkout Comment:") != -1) {
                let comments = value.comments.split("Checkout Comment:");
                scomments = comments[0];
                ccomments = comments[1];
            }else{
                scomments = value.comments;
            }
            if (scomments) {
                html +=
                    '<p style="margin:2px 0;">Special Comments: <br><span style="color:red">' +
                    scomments + '</span> </p>';
            }
            if (ccomments) {
                html +=
                    '<p style="margin:2px 0;">Checkout Comments: <br><span style="color:red">' +
                    ccomments + '</span> </p>';
            }
        }
        html += '</td>';
        html += '</tr>';
    });
    //   added by arshad /////
    if (data.delivery_type == "delivery") {
        html +=
            '<tr style="padding:3px 0"><td style="padding:3px 10px; border-bottom:2px solid #000"><p style="margin:2px 0"> Delivery Charge: <span class="pull-right"> $ ' +
            data.delivery_amount + ' </span> </p></td></tr>';

    }
    if (data.gst >0) {
        html +=
            '<tr style="padding:3px 0"><td style="padding:3px 10px; border-bottom:2px solid #000"><p style="margin:2px 0"> Card Surcharge: <span class="pull-right"> $ ' +
            parseFloat(data.gst).toFixed(2) + ' </span> </p></td></tr>';

    }

    html +=
        '<tr style="padding:3px 0"><td style="padding:3px 10px;"><p style="margin:2px 0"> Total Price: <span class="pull-right"> $ ' +
        data.total_amount + ' </span> </p></td></tr>';
    html += '</tbody></table></div></div>';
    return html;
};

export const menuItemDetails = (menu, order_no) => {
    let hmtl = `
    <tr style="font-size: 14px">
        <td>${menu.menu_name}</td>
        <td>${menu.menu_size}</td>
        <td>${menu.menu_qty}</td>
        <td>${"$" + menu.menu_price.toFixed(2)}</td>
        <td>${"$" + (menu.menu_price * menu.menu_qty).toFixed(2)}</td>
        <td>${"$" + menu.selcetdToppings[0].def_ing_price.toFixed(2)}</td>
        <td>${"$" + menu.total_menu_price.toFixed(2)}</td>
        <td>${menu.selcetdToppings[0].def_ing_name}</td>
    </tr>
    `;
    $("#menuItemDetails_" + order_no).append(hmtl);
};

